import { PlusIcon } from "lucide-react";

import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Spinner } from "@/components/ui/spinner";

import { InteractionBuilderProps } from "../../types/interactionBuilder";
import DecayPeriodSelector from "./DecayPeriodSelector";
import EntitySelector from "./EntitySelector";
import EntityTypeToggle from "./EntityTypeToggle";
import InteractionSelector from "./InteractionSelector";
import InteractionsList from "./InteractionsList";

export const InteractionBuilder = (props: InteractionBuilderProps) => {
  const {
    personaName,
    onPersonaNameChange,
    onCompute,
    isComputing,
    profiles,
    getDefaultProfileId,
    state,
    onSetEntityType,
    onSetSelectedEntity,
    onSetInteractionType,
    onSetSelectedPeriod,
    onAddInteraction,
    onRemoveInteraction,
  } = props;

  const profileId = getDefaultProfileId(
    state._entityType,
    state._interactionType,
  );
  const activeProfile = profiles.find((p) => p.id === profileId) ?? null;

  return (
    <div className="flex flex-col gap-4">
      <div className="space-y-1">
        <Label htmlFor="persona-name">Persona name</Label>
        <Input
          id="persona-name"
          value={personaName}
          onChange={(e) => onPersonaNameChange(e.target.value)}
          placeholder="e.g. Jazz fan in Athens"
        />
      </div>
      <div className="rounded-lg border border-border p-4 space-y-4">
        <p className="text-sm font-medium">Add an interaction</p>
        <EntityTypeToggle
          entityType={state._entityType}
          onChange={onSetEntityType}
        />
        <InteractionSelector
          value={state._interactionType}
          entityType={state._entityType}
          onChange={onSetInteractionType}
        />
        <EntitySelector
          value={state._selectedEntity}
          entityType={state._entityType}
          onChange={onSetSelectedEntity}
        />
        <DecayPeriodSelector
          selectedPeriod={state._selectedPeriod}
          onChange={onSetSelectedPeriod}
          activeProfile={activeProfile}
        />

        <Button
          onClick={onAddInteraction}
          disabled={!state._selectedEntity}
          className="w-full"
          variant="outline"
        >
          <PlusIcon className="mr-1 h-4 w-4" />
          Add interaction
        </Button>
      </div>
      <div className="overflow-y-auto max-h-72">
        <InteractionsList
          interactions={state.interactions}
          onRemove={onRemoveInteraction}
        />
      </div>
      <Button
        onClick={() => onCompute(state.interactions)}
        disabled={state.interactions.length === 0 || isComputing}
        className="w-full mt-2"
      >
        {isComputing ? (
          <>
            <Spinner className="mr-2 h-4 w-4" />
            Analysing…
          </>
        ) : (
          "Run analysis"
        )}
      </Button>
    </div>
  );
};
